import { Injectable } from "@angular/core";
import { TreeNode } from "primeng/api";

@Injectable({
    providedIn: 'root'
})
export class NodesCacheService {
    private cachedNodes: TreeNode[] = [];
    private cacheKey: string = ""; // entityType|businessCode

    public getNodes(): TreeNode[] {
        return this.cachedNodes;
    }

    public needReload(entityType: number, businessCode: string): boolean {
        return this.cacheKey != `${entityType}|${businessCode}` || !this.cachedNodes.length;
    }

    public setNodes(nodes: TreeNode[], entityType: number, businessCode: string): void {
        this.cacheKey = `${entityType}|${businessCode}`;
        this.cachedNodes = nodes;
    }

    public clearCache(): void {
        this.cachedNodes = [];
        this.cacheKey = "";
    }
}